class GeneralTriageQuestion {
  constructor(title, tag) {
    this.title = title;
    this.tag = tag;
  }
}
export default {
  inject: ['load'],
  data() {
    return {
      generalTriageQuestion: new GeneralTriageQuestion('', ''),
      generalTriageQuestions: null,
    };
  },
  methods: {
    getGeneralTriageQuestions: function () {
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store.dispatch('getGeneralTriageQuestions').then(() => {
        if (this.$store.state.generalTriageQuestionModule.successFlag) {
          this.generalTriageQuestions =
            this.$store.state.generalTriageQuestionModule.generalTriageQuestions;
          if (this.formLoad) {
            this.genaralTriageMap = [];
            this.genaralTriageMap.push({
              questionId: this.generalTriageQuestions.id,
              questionTag: this.generalTriageQuestions.tag ? this.generalTriageQuestions.tag : '-',
              answerColor: '#F4F4F4',
              fullTriageItem: {},
              cheifComplaintChage: false,
              cheifComplaintChageText: this.generalTriageQuestions.chiefComplaint
                ? this.generalTriageQuestions.chiefComplaint.title
                : null,
            });
            let hasChiefComlaint = false;
            if (this.generalTriageQuestions.chiefComplaint) {
              hasChiefComlaint = true;
            }
            this.genaralTriage = {
              questionId: this.generalTriageQuestions.id,
              questionTitle: this.generalTriageQuestions.title,
              hasChiefComlaint: hasChiefComlaint,
              isGeneral: this.generalTriageQuestions.isGeneral,
              answers: [],
            };
            if (this.generalTriageQuestions.triageAnswers) {
              for (let i = 0; i < this.generalTriageQuestions.triageAnswers.length; i++) {
                let color = '#212121';
                if (
                  this.generalTriageQuestions.triageAnswers[i].rank !== null ||
                  this.generalTriageQuestions.triageAnswers[i].rank !== undefined
                ) {
                  color = this.checkRankForColor(this.generalTriageQuestions.triageAnswers[i].rank);
                }
                this.genaralTriage.answers.push({
                  answerId: this.generalTriageQuestions.triageAnswers[i].id,
                  answerTitle: this.generalTriageQuestions.triageAnswers[i].title,
                  answerHint: this.generalTriageQuestions.triageAnswers[i].hint
                    ? this.generalTriageQuestions.triageAnswers[i].hint
                    : '-',
                  answerRank: this.generalTriageQuestions.triageAnswers[i].rank
                    ? this.generalTriageQuestions.triageAnswers[i].rank
                    : null,
                  color: color,
                  hint: this.generalTriageQuestions.triageAnswers[i].hint
                    ? this.generalTriageQuestions.triageAnswers[i].hint
                    : '-',
                  questionCheifComlpaint: this.generalTriageQuestions.chiefComplaint
                    ? this.generalTriageQuestions.chiefComplaint.title
                    : null,
                });
              }
            }
            this.genaralTriageMap[0].fullTriageItem = this.genaralTriage;
            this.generalTriageCounter = 1;
          }
          if (this.load.val) {
            this.load.val = false;
          }
        } else {
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.generalTriageQuestionModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.getGeneralTriageQuestions();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else if (this.$store.state.generalTriageQuestionModule.error400) {
            this.$store.dispatch('csrf').then(() => {
              if (this.$store.state.loginModule.successFlag) {
                this.getGeneralTriageQuestions();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    getGeneralTriageQuestionsWhiteQuestionId: function (questionId) {
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store.dispatch('getGeneralTriageQuestionsWithId', questionId).then(() => {
        if (this.$store.state.generalTriageQuestionModule.successFlag) {
          this.generalTriageQuestions =
            this.$store.state.generalTriageQuestionModule.generalTriageQuestions;
          if (this.load.val) {
            this.load.val = false;
          }
        } else {
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.generalTriageQuestionModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.getGeneralTriageQuestionsWhiteQuestionId(questionId);
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else if (this.$store.state.generalTriageQuestionModule.error400) {
            this.$store.dispatch('csrf').then(() => {
              if (this.$store.state.loginModule.successFlag) {
                this.getGeneralTriageQuestionsWhiteQuestionId(questionId);
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    addGeneralTriageQuestionRootFunction: function () {
      if (!this.generalTriageQuestion.title) {
        this.snackText = 'عنوان سوال نمی تواند خالی باشد';
        this.$refs.snackRef.snackModel = true;
        this.snackColor = '#FF5252';
        this.snakIcon = 'mdi-information';
        this.disabelConfirm = false;
        return;
      }
      if (!this.generalTriageQuestion.title.replace(/\s/g, '').length) {
        this.snackText = 'عنوان سوال نمی تواند خالی باشد';
        this.$refs.snackRef.snackModel = true;
        this.snackColor = '#FF5252';
        this.snakIcon = 'mdi-information';
        this.disabelConfirm = false;
        return;
      }
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store.dispatch('addGeneralTriageQuestionRoot', this.generalTriageQuestion).then(() => {
        if (this.$store.state.generalTriageQuestionModule.successFlag) {
          this.$refs.confirm.showConfirmDialog = false;
          this.showAddEditModal = false;
          this.disabelConfirm = false;
          this.snackText = ' سوال با موفقیت اضافه شد';
          this.$refs.snackRef.snackModel = true;
          this.snackColor = '#4CAF50';
          this.snakIcon = 'mdi-check-circle';
          if (this.load.val) {
            this.load.val = false;
          }
          this.generalTriageQuestion = new GeneralTriageQuestion('', '');
          this.getGeneralTriageQuestions();
        } else {
          this.disabelConfirm = false;
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.generalTriageQuestionModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.addGeneralTriageQuestionRootFunction();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else if (this.$store.state.generalTriageQuestionModule.error400) {
            this.$store.dispatch('csrf').then(() => {
              if (this.$store.state.loginModule.successFlag) {
                this.addGeneralTriageQuestionRootFunction();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    addGeneralTriageQuestionFunction: function () {
      if (!this.generalTriageQuestion.title) {
        this.snackText = 'عنوان سوال نمی تواند خالی باشد';
        this.$refs.snackRef.snackModel = true;
        this.snackColor = '#FF5252';
        this.snakIcon = 'mdi-information';
        this.disabelConfirm = false;
        return;
      }
      if (!this.generalTriageQuestion.title.replace(/\s/g, '').length) {
        this.snackText = 'عنوان سوال نمی تواند خالی باشد';
        this.$refs.snackRef.snackModel = true;
        this.snackColor = '#FF5252';
        this.snakIcon = 'mdi-information';
        this.disabelConfirm = false;
        return;
      }
      this.generalTriageQuestion.answerId = this.previousAnswerId;
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store.dispatch('addGeneralTriageQuestion', this.generalTriageQuestion).then(() => {
        if (this.$store.state.generalTriageQuestionModule.successFlag) {
          this.$refs.confirm.showConfirmDialog = false;
          this.showAddEditModal = false;
          this.disabelConfirm = false;
          this.snackText = ' سوال با موفقیت اضافه شد';
          this.$refs.snackRef.snackModel = true;
          this.snackColor = '#4CAF50';
          this.snakIcon = 'mdi-check-circle';
          if (this.load.val) {
            this.load.val = false;
          }
          this.generalTriageQuestion = new GeneralTriageQuestion('', '');
          this.generalTriageQuestions =
            this.$store.state.generalTriageQuestionModule.generalTriageQuestions;
          //this.getGeneralTriageQuestionsWhiteQuestionId(Number(routeInfo[1]));
        } else {
          this.disabelConfirm = false;
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.generalTriageQuestionModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.addGeneralTriageQuestionFunction();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else if (this.$store.state.generalTriageQuestionModule.error400) {
            this.$store.dispatch('csrf').then(() => {
              if (this.$store.state.loginModule.successFlag) {
                this.addGeneralTriageQuestionFunction();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    getGeneralTriageQuestionFunction: function (id) {
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store.dispatch('getGeneralTriageQuestion', id).then(() => {
        if (this.$store.state.generalTriageQuestionModule.successFlag) {
          this.generalTriageQuestion =
            this.$store.state.generalTriageQuestionModule.generalTriageQuestion;
          if (this.load.val) {
            this.load.val = false;
          }
        } else {
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.generalTriageQuestionModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.getGeneralTriageQuestionFunction(id);
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else if (this.$store.state.generalTriageQuestionModule.error400) {
            this.$store.dispatch('csrf').then(() => {
              if (this.$store.state.loginModule.successFlag) {
                this.getGeneralTriageQuestionFunction(id);
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    editGeneralTriageQuestionFunction: function () {
      if (!this.generalTriageQuestion.title) {
        this.snackText = 'عنوان سوال نمی تواند خالی باشد';
        this.$refs.snackRef.snackModel = true;
        this.snackColor = '#FF5252';
        this.snakIcon = 'mdi-information';
        this.disabelConfirm = false;
        return;
      }
      if (!this.generalTriageQuestion.title.replace(/\s/g, '').length) {
        this.snackText = 'عنوان سوال نمی تواند خالی باشد';
        this.$refs.snackRef.snackModel = true;
        this.snackColor = '#FF5252';
        this.snakIcon = 'mdi-information';
        this.disabelConfirm = false;
        return;
      }
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store.dispatch('editGeneralTriageQuestion', this.generalTriageQuestion).then(() => {
        if (this.$store.state.generalTriageQuestionModule.successFlag) {
          this.$refs.confirm.showConfirmDialog = false;
          this.disabelConfirm = false;
          this.showAddEditModal = false;
          if (this.load.val) {
            this.load.val = false;
          }
          this.mounte();
          this.snackText = ' سوال با موفقیت ویرایش شد';
          this.$refs.snackRef.snackModel = true;
          this.snackColor = '#4CAF50';
          this.snakIcon = 'mdi-check-circle';
          this.generalTriageQuestion = new GeneralTriageQuestion('', '');
        } else {
          this.disabelConfirm = false;
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.generalTriageQuestionModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.editGeneralTriageQuestionFunction();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else if (this.$store.state.generalTriageQuestionModule.error400) {
            this.$store.dispatch('csrf').then(() => {
              if (this.$store.state.loginModule.successFlag) {
                this.editGeneralTriageQuestionFunction();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    deleteGeneralTriageQuestionFunction: function () {
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store.dispatch('deleteGeneralTriageQuestion', this.generalTriageQuestionId).then(() => {
        if (this.$store.state.generalTriageQuestionModule.successFlag) {
          this.disabelConfirm = false;
          this.$refs.confirm.showConfirmDialog = false;
          if (this.load.val) {
            this.load.val = false;
          }
          this.mounte();
          this.snackText = ' سوال با موفقیت حذف شد';
          this.$refs.snackRef.snackModel = true;
          this.snackColor = '#4CAF50';
          this.snakIcon = 'mdi-check-circle';
        } else {
          this.disabelConfirm = false;
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.generalTriageQuestionModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.deleteGeneralTriageQuestionFunction();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else if (this.$store.state.generalTriageQuestionModule.error400) {
            this.$store.dispatch('csrf').then(() => {
              if (this.$store.state.loginModule.successFlag) {
                this.deleteGeneralTriageQuestionFunction();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    showError: function () {
      this.snackText = this.$store.state.generalTriageQuestionModule.error;
      this.$refs.snackRef.snackModel = true;
      this.snackColor = '#FF5252';
      this.snakIcon = 'mdi-information';
    },
  },
};
